// src/utils/index.js
import router from "@/router";

// 导出 os 对象
export let os = (function () {
  var u = navigator.userAgent;
  return {
    trident: /(?:Trident)/.test(u), // IE内核
    presto: /(?:Presto)/.test(u), // opera内核
    webKit: /(?:AppleWebKit)/.test(u), // 苹果、谷歌内核
    gecko: /(?:Gecko)/.test(u) && !/(?:KHTML)/.test(u), // 火狐内核
    mobile: /(?:AppleWebKit.*Mobile.*)/.test(u), // 是否为移动终端
    ios: /(?:\(i[^;]+;( U;)? CPU.+Mac OS X)/.test(u), // ios终端
    android: /(?:Android)/.test(u) || /(?:Adr)/.test(u) || /(?:OpenHarmony)/.test(u), // android终端
    iPhone: /(?:iPhone)/.test(u), // 是否为iPhone或者QQHD浏览器
    iPad: /(?:iPad)/.test(u), // 是否iPad
    apple: /(?:Mac)/.test(u) || /(?:iPhone)/.test(u) || /(?:iPad)/.test(u) || /(?:Macintosh)/.test(u), // 是否是苹果设备
    webApp: /(?:Safari)/.test(u), // 是否web应该程序，没有头部与底部
    weixin: /(?:MicroMessenger)/.test(u), // 是否微信
    hongMeng: /(?:OpenHarmony)/.test(u), // 是否鸿蒙
    qq: u.match(/\sQQ/i) == " qq", // 是否QQ
    app: /(?:ddyy)/.test(u) || /(?:dmxq)/.test(u) || /(?:yinger)/.test(u) || /(?:meme)/.test(u) || /(?:sdmt)/.test(u) || /(?:jiumi)/.test(u) || /(?:xingyu)/.test(u),
    appName: (/(?:ddyy)/.test(u) && "ddyy") || (/(?:dmxq)/.test(u) && "dmxq") || (/(?:meme)/.test(u) && "meme") || (/(?:yinger)/.test(u) && "yinger") || (/(?:jiumi)/.test(u) && "jiumi") || (/(?:sdmt)/.test(u) && "sdmt") || (/(?:xingyu)/.test(u) && "xingyu") || (/(?:Electron)/.test(u) && "dmxq"),
    isAppStore: /(?:appstore)/.test(u), // 是否是ios的appstore包
    channel: /(?:douyin)/.test(u) && "douyin",
    electron: /Electron/.test(u), // 是否是electron

    // 安卓各大手机品牌识别
    huawei: /(?:Huawei|HONOR)/i.test(u) || /(?:OpenHarmony)/.test(u), // 华为/荣耀
    xiaomi: /(?:Mi \d|Redmi|XiaoMi|MIUI)/i.test(u), // 小米/红米
    oppo: /(?:OPPO|PACM00|PBEM00|PBAM00|Realme)/i.test(u), // OPPO/真我
    vivo: /(?:vivo)/i.test(u), // vivo
    samsung: /(?:Samsung|SM-|SCH-|GT-|SGH-)/i.test(u), // 三星
    meizu: /(?:Meizu|MZ-)/i.test(u), // 魅族
    oneplus: /(?:ONEPLUS|ONE)/i.test(u), // 一加
  };
})();




// 创建简单的工具对象
const $utils = {
  os,
  // 可以在这里添加其他工具方法
  isWechat: () => os.weixin,
  isIOS: () => os.ios || os.apple,
  isAndroid: () => os.android || os.hongMeng,
};

// Vue 插件安装
$utils.install = function (Vue) {
  Vue.prototype.$utils = $utils;
};

export default $utils;